import { useMemo } from 'react';
import { DataGrid, type DataGridColumn } from '@/components/tables/DataGrid';
import { formatNumber, formatDateTime } from '@/utils/format';
import type { PortfolioEquityDetailedRowDto } from '@/api/types/portfolioEquity';

const n = (v: number | null | undefined) => (v == null || Number.isNaN(v) ? '0.00' : formatNumber(v, 2));

interface DetailedTabProps {
  rows: PortfolioEquityDetailedRowDto[];
  isLoading: boolean;
}

export function DetailedTab({ rows, isLoading }: DetailedTabProps) {
  const columns = useMemo<DataGridColumn<PortfolioEquityDetailedRowDto>[]>(
    () => [
      { key: 'uniqueId', title: 'Unique ID', className: 'text-start', value: (r) => r.uniqueId ?? '' },
      { key: 'login', title: 'Login', className: 'text-start', value: (r) => r.login },
      { key: 'registrationDate', title: 'Login Reg Date', className: 'text-start', value: (r) => r.registrationDate ?? '', cell: (r) => formatDateTime(r.registrationDate) },
      { key: 'currency', title: 'Acc Currency', className: 'text-start', value: (r) => r.currency ?? '' },
      { key: 'mifidClassification', title: 'MiFid Classification', className: 'text-start', value: (r) => r.mifidClassification ?? '' },
      { key: 'balanceRc', title: 'Balance RC', className: 'text-end', value: (r) => r.balanceRc, cell: (r) => (r.isMissing ? 'N/A' : n(r.balanceRc)) },
      { key: 'equityRc', title: 'Equity RC', className: 'text-end', value: (r) => r.equityRc, cell: (r) => (r.isMissing ? 'N/A' : n(r.equityRc)) },
      { key: 'floatingRc', title: 'Floating RC', className: 'text-end', value: (r) => r.floatingRc, cell: (r) => (r.isMissing ? 'N/A' : n(r.floatingRc)) },
      { key: 'country', title: 'Country', className: 'text-start', value: (r) => r.country ?? '' },
      { key: 'connector', title: 'Connector', className: 'text-start', value: (r) => r.connector ?? '' },
    ],
    [],
  );

  return (
    <DataGrid
      columns={columns}
      data={rows}
      rowKey={(r) => `${r.connector}:${r.login}`}
      pageSize={5}
      includeExcel
      excelFileName="Portfolio Equity"
      emptyMessage={isLoading ? 'Loading…' : 'No data for the current filters.'}
    />
  );
}
